
/* Graph Editor */
import { AfterViewInit, Component, EventEmitter, HostBinding, Input, NgModule, OnInit, Output } from '@angular/core';
import { ShowdownModule } from '../showdown.module';
import { SharedModule } from '../../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { EditorLanguages } from '../../../../../constants/editor-languages';
import { CodeSampleModule } from '../code-sample.module';
import { SharedExportService } from '../../services/shared-export.service';
import { EventsStatsComponent } from './events-stats.component';

import { loadScript } from '../../../../../shared/ultils';
import { EventsChartComponent } from './events-chart.component';

declare var window: any;
declare var document: any;
declare var Graph: any;
declare var mxUtils: any;
declare var mxResources: any;
declare var mxLanguage: any;
declare var mxCodec: any;
declare var RESOURCE_BASE: any;
declare var STYLE_PATH: any;

declare var $: any;


export class HackResultsViewerComponent implements OnInit, AfterViewInit {
	 public hackResults: any = null;
	 public hackReports: any = null;
	 public candidate: any = null;
	 public uiEventsReport: any = {};
	 public credentials: any = null;
	 public pdfMode = false;
	 public onCloseModal = new EventEmitter();

	 public get pdfModeClass() { return this.pdfMode; };

	public exportState: any = {
		loading: false,
		finished: false,
		viewLink: ''
	};
	public sourceMap: any = {
		posthog: 'Version 2',
		sessionstack: 'Version 1',
	};

	public chartsLoaded = false;
	public allEditorLanguages = EditorLanguages;
	public landingPagesUrl: string = process.env.LEGACY_PUBLIC_URL;

	constructor(private sharedExportService: SharedExportService) {}

	public async ngOnInit() {
		const chart  = await loadScript('assets/vendor/chart/chart.min.js', 'chartjs-script');
		this.chartsLoaded = true;
	}

	public ngAfterViewInit() {
		this.setupGraphEditors();
		this.setupTooltips();
		this.initHackKnob();
	}

	public closeModal() {
		this.onCloseModal.emit();
	}

	public onExportResultsClick(): void {
		if (!this.credentials) {
			return;
		}

		this.exportState.loading = true;
		this.sharedExportService.getCandidateHackResults(this.credentials.clientId, this.credentials.candidateId, this.credentials.hackId).subscribe(
			(link) => {
				this.exportState.loading = false;
				this.exportState.finished = true;
				this.exportState.viewLink = link;
			}
		);
	}

	public overallScoreBreakDownNav(event) {
		event.preventDefault();
		const elm = event.target || event.srcElement;
		if (!elm) {
			return;
		}

		const targetHost = document.querySelector(elm.getAttribute('href'));
		if (!targetHost) {
			return;
		}

		targetHost.scrollIntoView({behavior: 'smooth'});
	}

	private setupGraphEditors(): void {
		if (this.pdfMode) {
			return;
		}

		if (window.graphEditorInitialized) {
			setTimeout(() => {
				if (this.hackResults.diagram_challenge_results && this.hackResults.diagram_challenge_results.challenges && this.hackResults.diagram_challenge_results.challenges.length) {
					for (let challenge of this.hackResults.diagram_challenge_results.challenges) {
						let code = '';
						if (challenge.result) {
							code = challenge.result.code ? challenge.result.code : '';
						}

						this.initGraphEditor(challenge.id, code);
					}
				}
			}, 10);

			return;
		}

		window.__initGrapheditor(() => {
			window.graphEditorInitialized = true;

			setTimeout(() => {
				if (this.hackResults.diagram_challenge_results && this.hackResults.diagram_challenge_results.challenges && this.hackResults.diagram_challenge_results.challenges.length) {
					for (let challenge of this.hackResults.diagram_challenge_results.challenges) {
						let code = '';
						if (challenge.result) {
							code = challenge.result.code ? challenge.result.code : '';
						}

						this.initGraphEditor(challenge.id, code);
					}
				}
			}, 10);
		});
	}

	private initGraphEditor(challengeId: string, code: string): void {
		mxResources.loadDefaultBundle = false;
		let bundle = mxResources.getDefaultBundle(RESOURCE_BASE, mxLanguage) ||
			mxResources.getSpecialBundle(RESOURCE_BASE, mxLanguage);

		mxUtils.getAll([bundle, STYLE_PATH + '/default.xml'], (xhr) => {
			let themes = new Object();
			themes[Graph.prototype.defaultThemeName] = xhr[1].getDocumentElement();

			let graph = new Graph(document.getElementById('challenge-diagram-wrapper-' + challengeId), null, null, null, themes, true);
			graph.resizeContainer = false;
			graph.setEnabled(false);
			graph.transparentBackground = false;

			let xmlDoc = mxUtils.parseXml(code);
			let codec = new mxCodec(xmlDoc);
			codec.decode(xmlDoc.documentElement, graph.getModel());
		});
	}

	private initHackKnob(): void {
		setTimeout(() => $('#hack-results-knob').knob(), 10);
	}

	private setupTooltips(): void {
		setTimeout(() => {
			$('[data-toggle="tooltip"]').tooltip();
		}, 10);
	}
static ctorParameters() { return [ { type: SharedExportService } ]; }}


export class HackResultsViewerModule {
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/components/hack-results-viewer/hack-results-viewer.module.ts